export function ensureTrailingSlash(urlPart: string): string {
	urlPart = (urlPart || '').trim();

	if (urlPart.endsWith('/')) {
		return urlPart;
	}

	return urlPart + '/';
}

export function removeStartingSlash(urlPart: string): string {
	urlPart = (urlPart || '').trim();

	if (urlPart.startsWith('/')) {
		return urlPart.substring(1);
	}

	return urlPart;
}
